var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as superagent from 'superagent';
import { isResponseBodyMessageError } from '../../util/ErrorUtil';
var RequestType;
(function (RequestType) {
    RequestType["GET"] = "get";
    RequestType["POST"] = "post";
    RequestType["DELETE"] = "delete";
    RequestType["PUT"] = "put";
    RequestType["PATCH"] = "patch";
})(RequestType || (RequestType = {}));
export class StatusError extends Error {
    constructor(statusCode) {
        super();
        this.status = statusCode;
    }
}
const createRestClient = (baseUrl) => {
    const validateResponse = (response) => {
        if (!response.ok) {
            throw new StatusError(response.status);
        }
    };
    const request = (agent) => __awaiter(void 0, void 0, void 0, function* () {
        let response;
        try {
            response = yield agent;
        }
        catch (e) {
            if (isResponseBodyMessageError(e)) {
                throw new Error(e.response.body.message);
            }
            else {
                throw e;
            }
        }
        validateResponse(response);
        return response;
    });
    const buildUrl = (url) => baseUrl + url;
    const buildRequestAgent = (method, url, type = 'json') => {
        const req = superagent[method];
        return req(buildUrl(url))
            .type(type)
            .set('X-Requested-With', 'XMLHttpRequest');
    };
    const get = ({ url = '', query } = {}) => __awaiter(void 0, void 0, void 0, function* () {
        if (query) {
            url += `?${query.build()}`;
        }
        const agent = buildRequestAgent(RequestType.GET, url);
        return request(agent);
    });
    const post = ({ url = '', data } = {}) => __awaiter(void 0, void 0, void 0, function* () {
        const agent = buildRequestAgent(RequestType.POST, url).send(data);
        return request(agent);
    });
    const patch = ({ url = '', data } = {}) => __awaiter(void 0, void 0, void 0, function* () {
        const agent = buildRequestAgent(RequestType.PATCH, url).send(data);
        return request(agent);
    });
    const put = ({ url = '', data } = {}) => __awaiter(void 0, void 0, void 0, function* () {
        const agent = buildRequestAgent(RequestType.PUT, url).send(data);
        return request(agent);
    });
    const deleteRequest = ({ url = '', data } = {}) => __awaiter(void 0, void 0, void 0, function* () {
        const agent = buildRequestAgent(RequestType.DELETE, url).send(data);
        return request(agent);
    });
    return {
        get: get,
        post: post,
        patch: patch,
        put: put,
        delete: deleteRequest
    };
};
export default createRestClient;
